/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-10 12:04:01
 * @FilePath: /portal2/unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/Images/Images.tsx
 */
import React from 'react';
// import css from './css.less';
import Image from '../../Components/Image/Image';
import { useDispatch, useSelector } from 'react-redux';
import { setThumbnailImage } from '../Slice';
import { useSingleImageEffect } from '@/src/components/Upload';

const ImageSection = (props) => {
  const thumbnailImage = useSelector(
    (state: any) => state.simpleProduct.thumbnailImage,
  );

  const [fileList, setFileList] = React.useState(
    thumbnailImage ? [thumbnailImage] : [],
  );
  useSingleImageEffect(thumbnailImage, fileList, setFileList);
  const dispatch = useDispatch();
  const onChange = (img) => {
    dispatch(setThumbnailImage(img));
  };
  return (
    <Image
      onChange={onChange}
      fileList={fileList}
      disabled={props.disabled}
      //thumbnailImage={thumbnailImage}
      setFileList={setFileList}
    />
  );
};
export default ImageSection;
